import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Location, NgIf } from '@angular/common';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { ConfigProvider } from "../../../config-provider.service";
import { OrganizationsNavigationProvider } from '../../../organizations/providers/navigation-provider';
import { CurrentUser } from '../../../common/providers/current-user';
import { CurrentUserRolesProvider } from '../../../organizations/providers/current-user-roles-provider';
import { AthleteRow, AthletesProvider } from '../../../athletes/providers/athletes-provider';
import {
  AgendaRow,
  CalendarDayData,
  CalendarDaySegment,
  TimeslotRow,
  TimeslotsProvider
} from '../../providers/timeslots-provider';
import { WeekService } from '../../../annual-plan/providers/weeks.services';
import { AnnualPlanService } from '../../../annual-plan/providers/annual-plans.services';
import { BreadcrumbProvider, Crumb } from '../../../breadcrumb/providers/breadcrumb-provider';
import { AgendaRights } from '../../providers/agenda-rights';
import { AnnualPlanData } from '../../../annual-plan/merger/annual-plan-data-merger';
import { GuestsProvider } from '../../../guests/providers/guests-provider';
import { CalendarExportDialogComponent } from '../../components/export-dialog/calendar-export-dialog.component';
import { AgendaService } from '../../agenda.service';
import { forkJoin, fromEvent, map, Observable, of, Subscription, switchMap, tap } from 'rxjs';
import moment from 'moment';
import { AgendaCommentRow, AgendaCommentsProvider } from '../../providers/agenda-comments-provider';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ErrorManagerService } from '../../../common/providers/error-manager-service';
import { SessionsProvider } from '../../../sessions/providers/sessions-provider';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Snackbar } from "../../../common/snackbar/snackbar";
import { Organization } from "../../../common/models/organization";
import { Library } from "../../../common/models/library";
import { Week } from "../../../common/models/week";
import { AnnualPlan } from "../../../common/models/annual-plan";
import { AnnualPlanMacroCycle } from "../../../common/models/annual-plan-macro-cycle";
import { AnnualPlanPhase } from "../../../common/models/annual-plan.phase";
import { AgendaComment } from "../../../common/models/agenda-comment";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { HasPendingChangesGuard } from "../../../common/guards/has-pending-changes";
import { ConfirmDialogComponent } from "../../../common/components/confirm-dialog/confirm-dialog";
import { OrganizationRole } from "../../../common/models/organization-role";
import { SnackbarDataInterface } from "../../../common/snackbar/snackbar-data-interface";
import { Timeslot } from "../../../common/models/timeslot";
import { User } from "../../../common/models/user";
import { MainActionComponent } from "../../../common/components/main-action/main-action";
import { PageContentComponent } from "../../../common/components/page-content/page-content";
import { AthleteSideMenuComponent } from "../../../athletes/components/side-menu/side-menu";
import { Error401Component } from "../../../common/components/error-401/error-401";
import { Error404Component } from "../../../common/components/error-404/error-404";
import { AgendasCalendarComponent } from "../../components/calendar/calendar";
import { AnnualPlanGraphComponent } from "../../../annual-plan/components/graph/annual-plan-graph.component";
import { SideMenuComponent } from "../../../common/components/side-menu/side-menu";
import {
  SessionsSessionListSideMenuComponent
} from "../../../sessions/components/sessions-list-side-menu/sessions-list-side-menu";
import { ModuleContentComponent } from "../../../common/components/module-content/module-content";
import { MatError, MatFormField, MatHint } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { HeaderComponent } from "../../../common/components/header-elitment/header-elitment";
import { MatMiniFabButton } from "@angular/material/button";
import { MatInput } from "@angular/material/input";
import { MatTooltip } from "@angular/material/tooltip";
import { FlexLayoutModule } from "@angular/flex-layout";
import { AgendaProvider } from "../../providers/agenda-provider";
import { CoachesProvider } from "../../../coaches/providers/coaches-provider";
import { AthleteCoach } from "../../../common/models/athlete-coach";
import { Coach } from "../../../common/models/coach";
import { catchError, debounceTime, distinctUntilChanged } from "rxjs/operators";
import { CdkDropListGroup } from "@angular/cdk/drag-drop";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import { MobileDiaryListContentComponent } from "../../../mobile/diary/diary-list-content/mobile-diary-list-content";
import {
  CalendarDuplicateFormModalComponent
} from "../../components/calendar-duplicate-form-modal/calendar-duplicate-form-modal";

@Component({
  selector: 'agendas-calendar-page',
  providers: [
    Snackbar
  ],
  styleUrls: ['./calendar.scss'],
  standalone: true,
  imports: [
    MainActionComponent,
    TranslateModule,
    PageContentComponent,
    AthleteSideMenuComponent,
    Error401Component,
    Error404Component,
    AgendasCalendarComponent,
    AnnualPlanGraphComponent,
    SideMenuComponent,
    SessionsSessionListSideMenuComponent,
    ModuleContentComponent,
    MatFormField,
    MatHint,
    MatError,
    MatIcon,
    HeaderComponent,
    NgIf,
    RouterLink,
    ReactiveFormsModule,
    MatMiniFabButton,
    MatInput,
    MatTooltip,
    FlexLayoutModule,
    CdkDropListGroup,
    CdkTextareaAutosize,
    MobileDiaryListContentComponent
  ],
  templateUrl: './calendar.html'
})
export class AgendasCalendarPageComponent implements OnInit, OnDestroy {
  public readonly CALENDAR_MOBILE_MAX_WIDTH: number = 750;

  private resizeObservable$: Observable<number> | undefined;
  public isMobileDisplay: boolean = false;


  public set currentDate(currentDate: Date) {
    this._currentDate = currentDate;
  }

  public get currentDate() {
    return this._currentDate;
  }

  get f() {
    return this.agendaCom.controls;
  }

  public readonly COMMENT_MAX_LENGTH: number = 5000;

  public pageTitle = '';
  public isLoading = true;
  public isSaveLoading = false;
  public isRefreshLoading = false;
  public isWorking = false;
  public isDuplicateModActive = false;
  public is401 = false;
  public is404 = false;
  public organization: Organization = {} as Organization;
  public rights: AgendaRights = new AgendaRights(this._utils);
  public timeslotRowsToDuplicate: TimeslotRow[] = [];

  public athleteUser: User = {} as User;
  public library: Library  = {} as Library;
  public viewedAthlete: AthleteRow = {} as AthleteRow;
  public weeks: any;
  public currentAnnualPlanWeek: Week |null = null;
  public clickedWeek: Week = {} as Week;
  public timeSegments = 2;
  public annualPlan: AnnualPlan = {} as AnnualPlan;
  public annualPlanMacroCycles: AnnualPlanMacroCycle[] = [];
  public annualPlanPhases: AnnualPlanPhase[] = [];
  public isEditModeOn = false;
  public agendaRow: AgendaRow | null = null;
  public currentAgendaComment: AgendaComment | null = null;
  public data: CalendarDayData[] = [];
  // public availableSessions: SessionRow[] = [];

  public collapseBefore: string = this._utils.DateToHm(new Date(0, 0, 0, 8, 0));
  public collapseAfter: string = this._utils.DateToHm(new Date(0, 0, 0, 18, 59));

  public agendaCom: FormGroup;
  private _currentDate: Date = new Date();

  private _viewedAthleteId = 0;
  private _agendaId = 0;

  private exportDialog: any;
  private _whenCloseBacktoUrl: string = '';

  private subscriptions: Subscription[] = [];

  constructor(
    public conf: ConfigProvider,
    public breadcrumbProvider: BreadcrumbProvider,
    public currentUser: CurrentUser,
    private dialog: MatDialog,
    private _utils: UtilsProvider,
    private _title: Title,
    private _currentUserRoles: CurrentUserRolesProvider,
    private _route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private _translater: TranslateService,
    private _toaster: MatSnackBar,
    private _athletesProvider: AthletesProvider,
    private annualPlanProvider: AnnualPlanService,
    private weekProvider: WeekService,
    private _changesGuard: HasPendingChangesGuard,
    private _timeslotsProvider: TimeslotsProvider,
    private _guestsProvider: GuestsProvider,
    private _agendaCommentsProvider: AgendaCommentsProvider,
    private snackbar: Snackbar,
    private agendasProvider: AgendaProvider,
    private coachesProvider: CoachesProvider,
    private fb: FormBuilder,
    private _activatedRouter: ActivatedRoute,
    private errorManagerService: ErrorManagerService,
    private agendaService: AgendaService,
  ) {
    // first check if the display is mobile
    this.isMobileDisplay = window.innerWidth <= this.CALENDAR_MOBILE_MAX_WIDTH;

    this.subscriptions.push(
      this.agendaService.currentDateSubject.subscribe((date: Date) => {
        // this._currentDate = date;
        this.currentDate = date;
      })
    );


    this.subscriptions.push(
      this._activatedRouter.queryParams.subscribe((params) => {
        if (params['backto']) {

          /**
           * !! Source de hack : je nettoie le protocole du lien et ajoute
           * le / (root) du début par sécurité. Si un utilisateur de saisir
           * le paramètre de l'url à la main, ça va le stopper.
           */
          this._whenCloseBacktoUrl = this._utils.clearUrlProtocole(params['backto']);
          if (this._whenCloseBacktoUrl.indexOf('/') !== 0) {
            // commence toujours par un / pour rester dans le domaine d'origine
            this._whenCloseBacktoUrl = '/' + this._whenCloseBacktoUrl;
          }
        }
      })
    );
    this.agendaCom = this.fb.group({
      comment: new FormControl('', [Validators.maxLength(this.COMMENT_MAX_LENGTH)])
    });
  }

  @HostListener('window:beforeunload')
  public doSomething() {
    return !this._changesGuard.hasChanges();
  }

  public ngOnInit() {
    this.subscriptions.push(
      this.windowResizeHandler().subscribe(),
    );

    this.subscriptions.push(
      this._route.data.subscribe((data: any) => {//{ organization: Organization; athlete: Athlete; library: Library }
        this.organization = data.organization;
        this.athleteUser = data.athlete;
        this.library = data.library;
      })
    );

    this.subscriptions.push(
      this._route.params.subscribe((params: any) => {

        // this._viewedAthleteId = parseInt(params['athleteId'], 10);
        this._agendaId = parseInt(params['agendaId'], 10);
        this.isEditModeOn = params['editMode'] === 'edit';
        this._currentDate = params['date'] ? moment.utc(params['date']).toDate() : new Date();

        this.subscriptions.push(
          this.annualPlanProvider.findActiveByAthleteUserId(this.organization, this.athleteUser.id!).subscribe((data: AnnualPlanData) => {

            if (data['plan']) {
              this.annualPlan = data['plan'];
              this.weeks = data['weeks'];
              this.annualPlanPhases = data['phases'];
              this.annualPlanMacroCycles = data['macroCycles'];
            }

            this.initPage().subscribe({
              error: (error) => this.onError(error)
            });
          })
        );
      })
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  private windowResizeHandler(): Observable<void> {
    return fromEvent(window, 'resize').pipe(
      debounceTime(500),
      map(() => {
        this.isMobileDisplay = window.innerWidth <= this.CALENDAR_MOBILE_MAX_WIDTH;
      }),
      distinctUntilChanged()
    );
  }

  public onEditClicked(): void {
    this.router.navigate([this.organization!.code, 'athletes', this.athleteUser.id, 'calendar', this._agendaId, this._utils.DateToYmd(this.currentDate), 'edit']);
  }

  public onDuplicateModeClicked(active: boolean): void {
    this.isDuplicateModActive = active;
  }

  public onTimeslotRowDuplicateCheckboxSelected(timeslotRow: TimeslotRow): void {
    // add or remove event (timeslotRow) from list of timeslotRowsToDuplicate
    if (this.timeslotRowsToDuplicate.includes(timeslotRow)) {
      this.timeslotRowsToDuplicate = this.timeslotRowsToDuplicate.filter((tsr) => timeslotRow !== tsr);
    } else {
      this.timeslotRowsToDuplicate.push(timeslotRow);
    }
  }

  public onCancelClicked(): void {
    if (this.isDuplicateModActive) {
      this.isDuplicateModActive = false;
      return;
    }
    if (this._whenCloseBacktoUrl) {
      this.router.navigateByUrl(this._whenCloseBacktoUrl);
    } else {
      this.router.navigate([this.organization!.code, 'athletes', this.athleteUser.id, 'calendar', this._agendaId, this._utils.DateToYmd(this.currentDate)]);
    }
  }

  public onRefreshClicked(): void {
    if (this._changesGuard.hasChanges()) {
      const dialog = this.dialog.open(ConfirmDialogComponent, {
        data: {
          confirmText: 'Changes_will_be_lost',
          confirmActionText: 'Confirm'
        }
      });
      this.subscriptions.push(
        dialog.afterClosed().subscribe((confirmed) => {
          if (confirmed) {
            this.refresh();
          }
        })
      );
    } else {
      this.refresh();
    }
  }

  public onSegmentChanged(event: any): void {
    if (!event) return
    this._changesGuard.registerChanges(() => {});
    this.onSaveClicked();
  }

  public onChangeComment() {
    this._changesGuard.registerChanges(() => {});
    this.onSaveClicked();
  }

  public onCreateNewSessionFromChild(running: boolean) {
    this.isWorking = running;
  }

  public onSaveClicked(): Subscription|boolean {
    if (this.isDuplicateModActive) {
      const duplicateDialog = this.dialog.open(CalendarDuplicateFormModalComponent, {
        data: {
          organization: this.organization,
          agenda: this.agendaRow!.agenda,
          timeslotRowsToDuplicate: this.timeslotRowsToDuplicate,
        },
      });
      const modalClosed$ = duplicateDialog.afterClosed();
      return modalClosed$.subscribe({
        next: (result) => {
          if (result.success) {
            this._toaster.open(this._translater.instant('Sessions_duplicated'), '', {duration: 5000});
            this.isDuplicateModActive = false;
          } else {
            this._toaster.open(this._translater.instant('Error_duplicating_sessions'), '', {duration: 5000});
          }
          this.timeslotRowsToDuplicate = [];
          return result.success;
        },
        error: (error) => {
          console.error("Error handling modal closing : ", error);
          return false;
        },
      });
    }

    if (this.agendaCom.controls['comment'].errors) {
      this._toaster.open(this._translater.instant('Week_comment_error'), '', {duration: 5000});
      return false;
    } else {
      this.isRefreshLoading = true;
      return this.save().subscribe({
        next: () => {
          this.isRefreshLoading = false;
          this._toaster.open(this._translater.instant('Agenda_saved'), '', {duration: 5000});
          this._changesGuard.unregisterChanges();
          return true;
        },
        error: (error) => {
          this.isRefreshLoading = false;
          this.errorManagerService.error(error);
          return false;
        },
      });
    }
  }

  public async canChangeDate$(currentDate: Date, nextDate: Date): Promise<boolean> {
    if (this.isEditModeOn) {
      if (this._changesGuard.hasChanges()) {
        const dialog = this.dialog.open(ConfirmDialogComponent, {
          data: {
            confirmText: 'Changes_will_be_lost',
            confirmActionText: 'Confirm'
          }
        });
        let dialogAfterClosed$ = dialog.afterClosed();
        this.subscriptions.push(dialogAfterClosed$.subscribe());
        let confirmed = await dialogAfterClosed$.toPromise();
        if (confirmed) {
          this._changesGuard.unregisterChanges();
        } else {
          return false;
        }
      }
      let urlTree = this.router.createUrlTree([this.organization!.code, 'athletes', this.athleteUser.id, 'calendar', this._agendaId, this._utils.DateToYmd(nextDate), 'edit']);
      await this.router.navigateByUrl(urlTree);
    } else {
      let urlTree = this.router.createUrlTree([this.organization!.code, 'athletes', this.athleteUser.id, 'calendar', this._agendaId, this._utils.DateToYmd(nextDate)]);
      await this.router.navigateByUrl(urlTree);
    }
    this.agendaService.emitDateChanged(nextDate);
    return false;
  };

  public sessionExport(check = false) {
    if (this._changesGuard.hasChanges()) {
      const dialog = this.dialog.open(ConfirmDialogComponent, {
        data: {
          confirmText: 'Export_Changes_will_be_lost',
          confirmActionText: 'Confirm'
        }
      });
      this.subscriptions.push(
        dialog.afterClosed().subscribe((confirmed) => {
          if (confirmed) {
            this.beginSessionExport();
          }
        })
      );
    } else {
      this.beginSessionExport();
    }
  }

  // PRIVATE METHODS

  private beginSessionExport() {
    this.exportDialog = this.dialog.open(CalendarExportDialogComponent, {
      data: {
        organization: this.organization,
        athlete: this.athleteUser,
        selectedWeek: this._currentDate
      }
    });

    this.subscriptions.push(
      this.exportDialog.afterClosed().subscribe((data: SnackbarDataInterface) => {
        if (data) {
          this.isLoading = true;
          this.snackbar.show(data);
          this.isLoading = false;
        }
      })
    );
  }

  private initPage(): Observable<void> {
    return this.loadData().pipe(
      map(() =>{
        this.initNav();
        this.isLoading = false;
      }),
    );
  }

  private initNav(): void {
    if (!this.rights.LIST) {
      this.is401 = true;
      return;
    }

    this.createPageTitle();
    this.createBreadcrumb();
  }

  private loadData(): Observable<any> {
    return this.agendasProvider.getAthleteAgenda(this.organization.id!, this.athleteUser.id!).pipe(
      switchMap((athleteAgenda) => {
        // TODO FG: the data loading processing and rights evaluation need refactoring
        // => the annual plan data is loaded somewhere else in a completely different fashion...
        // => it seems like the rights evaluation is performed 2 times

        this.rights.evaluateItemRight({
          user: this.currentUser.user!,
          organizationId: this.organization.id!,
          agenda: athleteAgenda,
          rolesIds: this._currentUserRoles.getRolesIds(this.organization.id!),
          athleteCoachRelations: this.athleteUser.athlete?.coaches?.map((coach: Coach) => {
            return {
              athleteId: this.athleteUser.id!,
              coachId: coach.id!,
            } as AthleteCoach;
          }) ?? [],
          athleteMemberships: this.athleteUser.organizationMemberships ?? [],
          coaches: [], // TODO : #154 - liste nécessaire ?
          athletes: [], // TODO : #154 - liste nécessaire ?
          athleteGuestRelations: [],
          guests: [], // TODO : #154 - liste nécessaire ?
        })
        this.agendaRow = {
          agenda: athleteAgenda,
          rights: this.rights.getItemRightsList(),
        };

        if (!this.organization || !this.agendaRow.agenda) {
          throw {status: 404};
        }

        if (!this.agendaRow.rights.view) {
          throw {status: 404};
        }

        const fromDate: Date = this._utils.firstDayOfWeek(this.currentDate);
        return forkJoin([
          this._currentUserRoles.getRolesIds(this.organization.id!),
          this._athletesProvider.getAthleteRow(this.organization.id!, this.athleteUser.id!),
          this._timeslotsProvider.getCalendarWeekData(this.organization, this.agendaRow.agenda.id!, this.currentDate, this.timeSegments),
          this._agendaCommentsProvider.getCommentOf(this.organization.id!, this.agendaRow.agenda.id!, this._utils.DateToYmd(fromDate)
          ).pipe(catchError((error) => {
              if (error.status === 404) {
                // ignore 404 errors
                return [null];
              }
              throw error;
            })
          )
        ]).pipe(
          map(([rolesIds, athlete, data, comment]: [number, AthleteRow, CalendarDayData[], AgendaComment |null]) => {
            this.viewedAthlete = athlete;
            this.data = data;
            this.currentAgendaComment = comment;

            this.currentAnnualPlanWeek = this.weekProvider.findRelatedWeek(this.currentDate, this.annualPlan, this.weeks);

            this.rights.evaluateScreenRights({
              rolesIds: [rolesIds],
            });

            this.agendaCom.controls['comment'].setValue(this.currentAgendaComment?.comment);

            return null;
          }),
        );
      }),
    );
  }

  private refresh(): void {
    this.isRefreshLoading = true;
    // FG: maintenant que les sessions sont créées en DB directement au moment de leur planification
    // (avant que l'agenda ne soit enregistré) et qu'elles ne sont synchronisées que lorsqu'elles
    // ont un timeslot associé, si un user B ouvre un onglet avant que le user A
    // n'enregistre son agenda, les sessions ne sont plus synchronisées car leur date de création
    // (au moment du drop dans le timeslot) est antérieure à la date de dernière sync
    // d'où ce vilain hack pour remonter 24h en arrière histoire d'être sûr de récupérer toutes
    // les données auxquelles a accès ce user...
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    this.initPage().subscribe({
      next: () => {
        this._changesGuard.unregisterChanges();
        this._toaster.open(this._translater.instant('Data_synchronized'), '', {duration: 5000});
        this.isRefreshLoading = false;
      },
      error: (error) => {
        this.isRefreshLoading = false;
        this.errorManagerService.error(error);
      }
    })
  }

  private save(): Observable<any> {
    const slots: Timeslot[] = [];
    this.data.forEach((day: CalendarDayData) => {
      day.segments.forEach((segment: CalendarDaySegment) => {
        segment.slots.forEach((row: TimeslotRow) => {
          slots.push(row.timeslot! as Timeslot);
        });
      });
    });
    const fromDate: Date = this._utils.firstDayOfWeek(this.currentDate);
    const toDate: Date = this._utils.lastDayOfWeek(this.currentDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    const weekComment: AgendaCommentRow = {
      agendaId: this.agendaRow?.agenda.id!,
      comment: this.agendaCom.controls['comment'].value ?? '',
      weekfirstday: this._utils.DateToYmd(fromDate)
    };
    return this._timeslotsProvider.saveCalendarWeek(
      this.organization!,
      this.agendaRow!.agenda,
      slots,
      this._utils.DateToYmdHis(fromDate, true),
      this._utils.DateToYmdHis(toDate, false),
      weekComment
    ).pipe(
      switchMap(() => {
        return this._timeslotsProvider.getCalendarWeekData(this.organization!, this.agendaRow?.agenda.id!, this.currentDate, this.timeSegments).pipe(
          switchMap((data: CalendarDayData[]) => {
            return this._agendaCommentsProvider.getCommentOf(this.organization.id!, weekComment.agendaId, weekComment.weekfirstday).pipe(
              map((comment: AgendaComment) => {
                this.data = data;
                this.currentAgendaComment = comment;

                if (this.currentAgendaComment) {
                  this.agendaCom.controls['comment'].setValue(this.currentAgendaComment.comment);
                }
                return null;
              }),
            );
          }),
        );
      })
    );
  }

  private createPageTitle() {
    this.pageTitle = this._translater.instant('Calendar');
    this._title.setTitle(this.pageTitle + ' | ' + this.conf.platformName);
  }

  private createBreadcrumb() {

    const crumbs: Crumb[] = [];
    if (!this._currentUserRoles.have(OrganizationRole.ID_ATHLETE, this.organization?.id!)) {
      crumbs.push({
        shortTitle: 'Athletes',
        title: 'Athletes',
        url: '/' + this.organization!.code + '/athletes'
      });
    }
    crumbs.push({
      shortTitle: this.viewedAthlete.user.firstName?.substr(0, 1) + '. ' + this.viewedAthlete.user.lastName,
      title: this.viewedAthlete.user.firstName + ' ' + this.viewedAthlete.user.lastName,
      url: '/' + this.organization!.code + '/athletes/' + this.viewedAthlete.user.id
    });
    crumbs.push({
      shortTitle: 'Calendar',
      title: 'Calendar',
      url: '/' + this.organization!.code + '/athletes/' + this.viewedAthlete.user.id + '/calendar/' + this.agendaRow?.agenda.id + '/' + this._utils.DateToYmd(this._currentDate)
    });
    if (this.isEditModeOn) {
      crumbs.push({
        shortTitle: 'Edition',
        title: 'Edition',
        url: '/' + this.organization!.code + '/athletes/' + this.viewedAthlete.user.id + '/calendar/' + this.agendaRow?.agenda.id + '/' + this._utils.DateToYmd(this._currentDate) + '/edit'
      });
    }
    this.breadcrumbProvider.setCrumbs(crumbs);
  }

  private onError(error: any): void {
    this.isLoading = false;
    this.isSaveLoading = false;
    this.isRefreshLoading = false;

    if (error.status === 404) {
      // this.is404 = true;
    } else if (error.status === 401) {
      this.is401 = true;
    } else {
      console.error("Calendar Page : ", error);
    }
  }
}
